import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  useEffect(() => {
    if (user && Array.isArray(user.wishlist)) setIds(user.wishlist);
    else setIds([]);
  }, [user]);

  const has = (productId) => ids.includes(productId);

  const toggle = async (product) => {
    if (!user) {
      toast.error("Entre na sua conta para favoritar peças");
      return;
    }
    try {
      const { data } = await api.post(`/wishlist/${product.id}`);
      setIds(data.wishlist);
      toast.success(data.added ? "Adicionado aos favoritos" : "Removido dos favoritos");
    } catch {
      toast.error("Não foi possível atualizar seus favoritos");
    }
  };

  return (
    <WishlistContext.Provider value={{ ids, has, toggle, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}
